export const PRODUCTS = {
  osha_safety_padlock: [
    {
      prod_id: "MNS-OS-ML",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/OSHA safety Padlock - with Metallic Shackle Available with - AlikeDiffer and Master key Options 38-40MM.min.png"),
      prod_title:
        "OSHA safety Padlock - with Metallic Shackle Available with - Alike/Differ and Master key Options 38-40MM",
      prod_desc:
        "To meet Osha’s Lockout/Tagout Standard, 29 CFR &1910.147 & 1910.269 Safety Isolation Padlock with Steel shackle Having the new management key technology 6/10 level management High Quality with waterproof Anti-corrosion and strong adhesive Side of the antiskid design can wear gloves Key retaining-ensures that padlock is not left unlocked,Easy to know personal ID Indicating the Corresponding padlock for easy management Key system: DIFFER KEY , ALIKE KEY Master Key Body material：Nylon ( composition of ABS + NYLON ) Shackle Material：Heavy coated carbide Steel Color：Red, Blue,Yellow, Green, Orange, White, Brown, Black, Purple Work temperature：0° – 250° F (-20° – 120° C) Body Height – 45mm Body width – 40mm Body depth – 20mm,shackle height – 38mm,shackle width – 20mm,shackle thickness – 6mm",
    },
    {
      prod_id: "MNS-OS-MLAK",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/OSHA safety Padlock - with Metallic Shackle Available with - Alike  key(with or Without Master Key Option available)38-40MM.min.jpg"),
      prod_title:
        "OSHA safety Padlock - with Metallic Shackle Available with - Alike key(with or Without Master Key Option available)38-40MM",
      prod_desc:
        "To meet Osha’s Lockout/Tagout Standard, 29 CFR &1910.147 & 1910.269 Safety Isolation Padlock with Steel shackle Having the new management key technology 6/10 level management High Quality with waterproof Anti-corrosion and strong adhesive Side of the antiskid design can wear gloves Key retaining-ensures that padlock is not left unlocked,Easy to know personal ID Indicating the Corresponding padlock for easy management Key system: DIFFER KEY , ALIKE KEY Master Key Body material：Nylon (composition of ABS + NYLON ) Shackle Material：Heavy coated carbide Steel Color：Red, Blue,Yellow, Green, Orange, White, Brown, Black, Purple Work temperature：0° – 250° F (-20° – 120° C) Body Height – 45mm Body width – 40mm Body depth – 20mm,shackle height – 38mm,shackle width – 20mm,shackle thickness – 6mm",
    },
    {
      prod_id: "MNS-OS-MLDK",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/OSHA safety Padlock - with Metallic Shackle Available with -Differ  key (with or Without Master Key Option available) 38-40MM.min.jpg"),
      prod_title:
        "OSHA safety Padlock - with Metallic Shackle Available with -Differ key (with or Without Master Key Option available) 38-40MM",
      prod_desc:
        "To meet Osha’s Lockout/Tagout Standard, 29 CFR &1910.147 & 1910.269 Safety Isolation Padlock with Steel shackle Having the new management key technology 6/10 level management High Quality with waterproof Anti-corrosion and strong adhesive Side of the antiskid design can wear gloves Key retaining-ensures that padlock is not left unlocked,Easy to know personal ID Indicating the Corresponding padlock for easy management Key system: DIFFER KEY , ALIKE KEY Master Key Body material：Nylon ( composition of ABS + NYLON ) Shackle Material：Heavy coated carbide Steel Color：Red, Blue,Yellow, Green, Orange, White, Brown, Black, Purple Work temperature：0° – 250° F (-20° – 120° C) Body Height – 45mm Body width – 40mm Body depth – 20mm,shackle height – 38mm,shackle width – 20mm,shackle thickness – 6mm",
    },
    {
      prod_id: "MNS-OS-MLM",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/OSHA safety Padlock - with Metallic Shackle Available with - AlikeDiffer and Master key Options 38-40MM.min.png"),
      prod_title:
        "OSHA safety Padlock - with Metallic Shackle Available with - Master key 38-40MM(Differ and Alike Key Option Avaialable)",
      prod_desc:
        "To meet Osha’s Lockout/Tagout Standard, 29 CFR &1910.147 & 1910.269 Safety Isolation Padlock with Steel shackle Having the new management key technology 6/10 level management High Quality with waterproof Anti-corrosion and strong adhesive Side of the antiskid design can wear gloves Key retaining-ensures that padlock is not left unlocked,Easy to know personal ID Indicating the Corresponding padlock for easy management Key system: DIFFER KEY , ALIKE KEY Master Key Body material：Nylon ( composition of ABS + NYLON ) Shackle Material：Heavy coated carbide Steel Color：Red, Blue,Yellow, Green, Orange, White, Brown, Black, Purple Work temperature：0° – 250° F (-20° – 120° C) Body Height – 45mm Body width – 40mm Body depth – 20mm,shackle height – 38mm,shackle width – 20mm,shackle thickness – 6mm",
    },
    {
      prod_id: "MNS-OS-DEL",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/OSHA-safety-Padlock-with-di-electric-Shackle-Available-With-ALIKE-DIFFER-&-MASTER-KEY38-40mm.min.png"),
      prod_title:
        "OSHA safety Padlock - with di-electric Shackle Available With- ALIKE /DIFFER & MASTER KEY38-40mm",
      prod_desc:
        "To meet Osha’s Lockout/Tagout Standard, 29 CFR &1910.147 & 1910.269 Safety Isolation OSHA Padlock with Nylon shackle Having the new management key technology 6/10 level management High Quality with waterproof Anti-corrosion and strong adhesive Side of the antiskid design can wear gloves Key retaining-ensures that padlock is not left unlocked,Easy to know personal ID Indicating the Corresponding padlock for easy management Key system: DIFFER KEY , ALIKE KEY Master Key Body material：Nylon ( composition of ABS + NYLON ) Shackle Material：Heavy coated carbide Steel Color：Red, Blue,Yellow, Green, Orange, White, Brown, Black, Purple Work temperature：0° – 250° F (-20° – 120° C) Body Height – 45mm Body width – 40mm Body depth – 20mm,shackle height – 38mm,shackle width – 20mm,shackle thickness – 6mm",
    },
    {
      prod_id: "MNS-OS-DEL-AK",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/OSHA safety Padlock - with Nylon Shackle Available with -Alike key (with or Without Master Key Option available) 38-40MM.min.jpg"),
      prod_title:
        "OSHA safety Padlock - with Nylon Shackle Available with -Alike key (with or Without Master Key Option available) 38-40MM",
      prod_desc:
        "To meet Osha’s Lockout/Tagout Standard, 29 CFR &1910.147 & 1910.269 Safety Isolation OSHA Padlock with Nylon shackle Having the new management key technology 6/10 level management High Quality with waterproof Anti-corrosion and strong adhesive Side of the antiskid design can wear gloves Key retaining-ensures that padlock is not left unlocked,Easy to know personal ID Indicating the Corresponding padlock for easy management Key system: DIFFER KEY , ALIKE KEY Master Key Body material：Nylon ( composition of ABS + NYLON ) Shackle Material：Heavy coated carbide Steel Color：Red, Blue,Yellow, Green, Orange, White, Brown, Black, Purple Work temperature：0° – 250° F (-20° – 120° C) Body Height – 45mm Body width – 40mm Body depth – 20mm,shackle height – 38mm,shackle width – 20mm,shackle thickness – 6mm",
    },
    {
      prod_id: "MNS-OS-DEL-DK",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/OSHA safety Padlock - with Nylon Shackle Available with -Differ key (with or Without Master Key Option available) 38-40MM.min.jpg"),
      prod_title:
        "OSHA safety Padlock - with Nylon Shackle Available with -Differ key (with or Without Master Key Option available) 38-40MM",
      prod_desc:
        "To meet Osha’s Lockout/Tagout Standard, 29 CFR &1910.147 & 1910.269 Safety Isolation OSHA Padlock with Nylon shackle Having the new management key technology 6/10 level management High Quality with waterproof Anti-corrosion and strong adhesive Side of the antiskid design can wear gloves Key retaining-ensures that padlock is not left unlocked,Easy to know personal ID Indicating the Corresponding padlock for easy management Key system: DIFFER KEY , ALIKE KEY Master Key Body material：Nylon ( composition of ABS + NYLON ) Shackle Material：Heavy coated carbide Steel Color：Red, Blue,Yellow, Green, Orange, White, Brown, Black, Purple Work temperature：0° – 250° F (-20° – 120° C) Body Height – 45mm Body width – 40mm Body depth – 20mm,shackle height – 38mm,shackle width – 20mm,shackle thickness – 6mm",
    },
    {
      prod_id: "MNS-OS-DEL-MK",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/OSHA-safety-Padlock-with Nylon-Shackle-Available with-Master-key 38-40MM(Differ and Alike Key-Option-Available.min.png"),
      prod_title:
        "OSHA safety Padlock - with Nylon Shackle Available with - Master key 38-40MM(Differ and Alike Key Option Avaialable)",
      prod_desc:
        "To meet Osha’s Lockout/Tagout Standard, 29 CFR &1910.147 & 1910.269 Safety Isolation OSHA Padlock with Nylon shackle Having the new management key technology 6/10 level management High Quality with waterproof Anti-corrosion and strong adhesive Side of the antiskid design can wear gloves Key retaining-ensures that padlock is not left unlocked,Easy to know personal ID Indicating the Corresponding padlock for easy management Key system: DIFFER KEY , ALIKE KEY Master Key Body material：Nylon ( composition of ABS + NYLON ) Shackle Material：Heavy coated carbide Steel Color：Red, Blue,Yellow, Green, Orange, White, Brown, Black, Purple Work temperature：0° – 250° F (-20° – 120° C) Body Height – 45mm Body width – 40mm Body depth – 20mm,shackle height – 38mm,shackle width – 20mm,shackle thickness – 6mm",
    },
    {
      prod_id: "MNS-JPL-LS",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Jacketed Long Shackle - Lockout Padlock - with 3 keys for one padlock in Multiple colors.min.jpg"),
      prod_title:
        "Jacketed Long Shackle - Lockout Padlock - with 3 keys for one padlock in Multiple colors",
      prod_desc:
        "Jacket padlock With Dielectric ABS body cover with Differ Key/Long Shackle Size. Available colors: Red, Blue,Yellow, Green, Orange, Black, White Dimensions: Body height : 40mm Body width : 42mm Body Depth : 19mm Shackle Height : 45mm Shackle Width : 20mm shackle thickness : 6mm",
    },
    {
      prod_id: "MNS-JPL-RS",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Jacketed Regular Shackle - Lockout Padlock -with 3 keys for one padlock in Multiple colors.min.jpg"),
      prod_title:
        "Jacketed Regular Shackle - Lockout Padlock -with 3 keys for one padlock in Multiple colors",
      prod_desc:
        "Jacket padlock With Dielectric ABS body cover with Differ Key with Regular/Small Shackle Size. Available colors: Red, Blue,Yellow, Green, Orange, Black, White Dimensions: Body height : 40mm Body width : 40mm Body Depth : 19mm Shackle Height : 23mm Shackle Width : 20mm shackle thickness : 6mm",
    },
  ],
  lockout_safety_tags: [
    {
      prod_id: "MNS-LT-2C",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Lockout-Do-Not-OperateTags-Double-Color.min.jpg"),
      prod_title: "Lockout Do Not OperateTags - Double Color",
      prod_desc:
        "Lockout DO NOT OPERATETAGS printed on 0.5mm Thick Plastic sheet. Double Color printing, Do not operate , Do not On, Do not start etc. Size : 77 x 138 mm in cut shape-1-SET(10 Nos)",
    },
    {
      prod_id: "MNS-LT-1C",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Lockout  Do Not OperateTags -Single Color.min.jpg"),
      prod_title: "Lockout Do Not OperateTags - Single Color",
      prod_desc:
        "Lockout DO NOT OPERATETAGS printed on 0.5mm Thick Plastic sheet. Double Color printing, Do not operate , Do not On, Do not start etc. Size : 77 x 138 mm in cut shape-1-SET(10 Nos)",
    },
    {
      prod_id: "MNS-FT",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Fire Inspection Record Tags.min.jpg"),
      prod_title: "Fire Inspection /Record Tags",
      prod_desc:
        "Fire Inspection Tags Printed on 0.5mm Thick Plastic sheet. Single & Double colour printing with provision of maintaining records of Months Size : 77 x 138 mm in top cut shape (Set of 10 Nos)",
    },
    {
      prod_id: "MNS-LT-PT",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Lockout Photo Tags.min.jpg"),
      prod_title: "Lockout Photo Tags",
      prod_desc:
        "Lockout DO NOT OPERATE PHOTO TAGS printed on 0.5mm Thick Plastic sheet. DOUBLE COLOR printing, Size : 77 x 138 mm in cut shape-1-SET(10 Nos)",
    },
    {
      prod_id: "MNS-LTT",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/LOTO-Transition Tag.min.jpg"),
      prod_title: "LOTO-Transition Tag",
      prod_desc:
        "Lockout LOTO TransitionTAGS printed on 0.5mm Thick Plastic sheet. DOUBLE COLOR printing, Size : 77 x 138 mm in cut shape-1-SET(10 Nos)",
    },
    {
      prod_id: "MNS-ELT",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Danger Equipment Locked Out Tag.min.jpg"),
      prod_title: "Danger Equipment Locked Out Tag",
      prod_desc:
        "Lockout Danger Equipment Locked Out Tag printed on 0.5mm Thick Plastic sheet.DOUBLE COLOR printing, Size : 77 x 138 mm in cut shape-1-SET(10 Nos)",
    },
    {
      prod_id: "MNS-LT-PT1",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Lockout Photo Tags-1.min.jpg"),
      prod_title: "Lockout Photo Tags-1",
      prod_desc:
        "Lockout DO NOT OPERATE PHOTO TAGS printed on 0.5mm Thick Plastic sheet. DOUBLE COLOR printing, Size : 77 x 138 mm in cut shape-1-SET(10 Nos)",
    },
    {
      prod_id: "MNS-ELP",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Danger Equipment Locked Out Tag-1.min.jpg"),
      prod_title: "Danger Equipment Locked Out Tag-1",
      prod_desc:
        "Equipment Locked out -Lockout DO NOT OPERATETAGS printed on 0.5mm Thick Plastic sheet. SINGLE COLOR printing, Size : 77 x 138 mm in cut shape-1-SET(10 Nos)",
    },
    {
      prod_id: "MNS-ST-R-R",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Scaffolding Tag Red color.min.jpg"),
      prod_title: "Scaffolding Tag Red color",
      prod_desc:
        "Scaffold Tags can also be fixed with cable tie with lockout devices, Material-Polyester/Plastic re-writable of thickness 0.3 mm - 0.5 mm, can be used Multiple times. Water/ Oil resistant, tags with eye lid to tie prevents it from any damage/ tear. Size - 96mm X 2mm(Set of 10 Nos)",
    },
    {
      prod_id: "MNS-ST-R-G",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Scaffolding Tag Green color.min.jpg"),
      prod_title: "Scaffolding Tag Green color",
      prod_desc:
        "caffold Tags can also be fixed with cable tie with lockout devices, Material-Polyester/Plastic re-writable of thickness 0.3 mm - 0.5 mm, can be used Multiple times, Water/ Oil resistant, tags with eye lid to tie prevents it from any damage/ tear. Size - 96mm X 2mm(Set of 10 Nos)",
    },
    {
      prod_id: "MNS-ST-R-Y",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Scaffolding Tag Yellow color.min.jpg"),
      prod_title: "Scaffolding Tag Yellow color",
      prod_desc:
        "Scaffold Tags can also be fixed with cable tie with lockout devices, Material-Polyester/Plastic re-writable of thickness 0.3 mm - 0.5 mm, can be used Multiple times, Water/ Oil resistant, tags with eye lid to tie prevents it from any damage/ tear. Size - 96mm X 2mm(Set of 10 Nos)",
    },
    {
      prod_id: "MNS-STH",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Scaffold Tag Holder.min.jpg"),
      prod_title: "Scaffold Tag Holder",
      prod_desc:
        "Scaffold Tag Holder use to hold the tag single molded made of ABS plastic material Size of holder : 300mm x 85.5 mm with inner round hole Cutout dia of Holder : 55.5 mm. It Can accommodate of tag Insert size : 76mm x 185.5 mm",
    },
    {
      prod_id: "MNS-STH-1",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Scaffold Tag Holder with Insert.min.jpg"),
      prod_title: "Scaffold Tag Holder with Insert",
      prod_desc: "Scafollding Tag Holder with Scaffolding Tag",
    },
    {
      prod_id: "MNS-ST-S-Y",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Scaffolding Tag Sqaure Yellow color.min.jpg"),
      prod_title: "Scaffolding Tag Sqaure Yellow color",
      prod_desc:
        "Scaffold tags Square Made of re writable Plastic material of thickness 0.3 mm - 0.5 mm ( +/- 10% ) with three colours printing Large Size tag of size – 76 x 186 mm (set of 10 Nos)",
    },
    {
      prod_id: "MNS-ST-S-R",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Scaffolding Tag Sqaure Red&Yellow color.min.jpg"),
      prod_title: "Scaffolding Tag Sqaure Red & Yellow color",
      prod_desc:
        "Scaffold tags Square Made of re writable Plastic material of thickness 0.3 mm - 0.5 mm ( +/- 10% ) with three colours printing Large Size tag of size – 76 x 186 mm (set of 10 Nos)",
    },

    {
      prod_id: "MNS-ST-S-G",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Scaffolding Tag Sqaure Green color.min.jpg"),
      prod_title: "Scaffolding Tag Sqaure Green color",
      prod_desc:
        "Scaffold tags Square Made of re writable Plastic material of thickness 0.3 mm - 0.5 mm ( +/- 10% ) with three colours printing Large Size tag of size – 76 x 186 mm (set of 10 Nos)",
    },

    {
      prod_id: "MNS-ST-S-R-1",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Scaffolding Tag Sqaure Red color.min.jpg"),
      prod_title: "Scaffolding Tag Sqaure Red color",
      prod_desc:
        "Scaffold tags Square Made of re writable Plastic material of thickness 0.3 mm - 0.5 mm ( +/- 10% ) with three colours printing Large Size tag of size – 76 x 186 mm (set of 10 Nos)",
    },

    {
      prod_id: "MNS-ST-S-Y-1",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Scaffolding Tag Sqaure Yellow color(Under Construction).min.jpg"),
      prod_title: "Scaffolding Tag Sqaure Yellow color (Under Construction)",
      prod_desc:
        "Scaffold tags Square Made of re writable Plastic material of thickness 0.3 mm - 0.5 mm ( +/- 10% ) with three colours printing Large Size tag of size – 76 x 186 mm (set of 10 Nos)",
    },
    {
      prod_id: "MNS-PEN",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Writing-Pen.min.png"),
      prod_title: "Writing pen specially for Tags",
      prod_desc:
        "Writing pen specially for Tags, It’s writing can be remove with eraser has been fixed at the back side of the marker.",
    },
  ],
  lockout_safety_hasps: [
    {
      prod_id: "MNS-LH",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/labeled-hasp.min.jpg"),
      prod_title: "Labeled Lockout Hasp",
      prod_desc:
        "Labeled Hasp - Material: Made by Stainless Steel or aluminium along with the powder coating and Danger or caution writing options on front and back side for better identification. Color: Basic colors of red, yellow, green and blue or can be varied as per the required quantity,Locking Arrangement: available with six, eight or ten holes provision for lockout purposes. Advantages: Additional authorized employees can also affix their respective padlocks in the device to fulfill group isolation necessities hence this device assist in the servicing operation, It allows the user to Wright their respective details in the provided captions, hence it doesn't required to attach Tag along with the device. Weight: 150 gram",
    },
    {
      prod_id: "MNS-VCHS-25mm",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Lockout Vinyl Molded coated Hasp Small RED  -having jaw size of 25mm.min.jpg"),
      prod_title:
        "Lockout Vinyl Molded coated Hasp Small RED -having jaw size of 25mm",
      prod_desc:
        "Lockout Hasp used for Group Locking for the energy source/Isolation Point which is been operated by various Authorized persons can accommodate 6 persons lock to meet Osha’s Lockout/Tagout Standard, 29 CFR &1910.147 & 1910.269, Material: Mild Stainless steel base with Poly propylene material grip on bottom portion Available sizes: Small Jaw – 25mm, Colour : Red,Blue,Yellow Dimensions: Jaw Diameter – 25mm, Height : 113mm Hole Diameter – 10mm Weight: 113 gms",
    },
    {
      prod_id: "MNS-VCHS-38mm",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Lockout Vinyl Molded coated Hasp Small RED  -having jaw size of 38 mm.min.png"),
      prod_title:
        "Lockout Vinyl Molded coated Hasp Small RED -having jaw size of 38 mm",
      prod_desc:
        "Lockout Hasp used for Group Locking for the energy source/Isolation Point which is been operated by various Authorized persons can accommodate 6 persons lock to meet Osha’s Lockout/Tagout Standard, 29 CFR &1910.147 & 1910.269, Material: Mild Stainless steel base with Poly propylene material grip on bottom portion Available sizes: Big Jaw – 38mm, Colour : Red,Blue,Yellow Dimensions: Jaw Diameter – 38mm, Height : 113mm Hole Diameter – 10mm Weight: 113 gms",
    },
    {
      prod_id: "MNS-PVCHS-25",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/LOCKOUT Powder Coated Hasp Small with red, yellow, green-having jaw size of 25 mm.min.png"),
      prod_title:
        "LOCKOUT Powder Coated Hasp Small with red, yellow, green-having jaw size of 25 mm",
      prod_desc:
        "Powder coated Hasp is used to Isolate the Electrical device for group locking, six people can lock/accomodate the device at a time and can be used on all type of power switches, it’s tamper steel, flame proof Dimension – Jaw diameter 25 mm for small hasp with Height 113 mm Weight – 80gm for small hasp Holes – 4,8",
    },
    {
      prod_id: "MNS-DEH-63",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Di-ElectricNon - conductive Hasp with 4 holes and 6 mm shackle.min.jpg"),
      prod_title:
        "Di-Electric/Non - conductive Hasp with 4 holes and 6 mm shackle",
      prod_desc:
        "Dielectric Yellow Hasp with Black shackle having 4 holes for padlocks group locking Use for MCB and electrical panel locking Chemical and Magnetic Resistant and completely insulated for Electrical panels Material : ABS Parts : 3 parts – Upper body, Slider part and Non conductive shackle with 4 holes Colour : Body Yellow and Shackle Black – Customized colour can make as per customer requirement. Dimensions : Body width – 62mm, Length – 65mm, thickness – 12mm Shackle width – 55mm and thickness – 6mm Weight : 50 / 55 gms according to shackle thickness",
    },
    {
      prod_id: "MNS-DEH-33",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Di-ElectricNon - conductive Hasp with 4 holes and 3 mm shackle.min.jpg"),
      prod_title:
        "Di-Electric/Non - conductive Hasp with 4 holes and 3 mm shackle",
      prod_desc:
        "Dielectric Yellow Hasp with Black shackle having 4 holes for padlocks group locking Use for MCB and electrical panel locking Chemical and Magnetic Resistant and completely insulated for Electrical panels Material : ABS Parts : 3 parts – Upper body, Slider part and Non conductive shackle with 4 holes Colour : Body Yellow and Shackle Black – Customized colour can make as per customer requirement. Dimensions : Body width – 62mm, Length – 65mm, thickness – 12mm Shackle width – 55mm and thickness – 3mm Weight : 50 / 55 gms according to shackle thickness",
    },
    {
      prod_id: "MNS-DEH-64",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Di-Electric Non - conductive Hasp with 6 holes.min.png"),
      prod_title: "Di-Electric Non - conductive Hasp with 6 holes",
      prod_desc:
        "Dielectric Hasp with Red molded shackle having 6 holes for padlocks group locking Use for MCB and electrical panel locking Chemical and Magnetic Resistant and completely insulated for Electrical panels Material : ABS Parts : 2 parts – Upper body and Slider part with 6 holes Colour : Red or Customized color can make as per customer requirement. Dimensions : Body Length – 175mm, shackle height – 80mm, hole dia – 9mm Weight :30 gms",
    },
    {
      prod_id: "MNS-DEH-4",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Non - conductive Hasp with 4 holes.min.png"),
      prod_title: "Non - conductive Hasp with 4 holes",
      prod_desc:
        "Material – Propylene / Nylon Di-Electric Multi Device Hasp made of strong rigid Propylene highly resistant to the chemical and can be utilized in magnetic field. Having totally FOUR hole slots to placed padlocks for Group isolation. Color – Red, Or any color customization as per the required quantity Dimension: outer Length 133 mm, shackle Height 64 mm, hole Diameter 9 mm Weight – 15 gm",
    },
  ],
  electrical_lockout: [
    {
      prod_id: "MNS-EPB",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Emergency SwitchMushroom push button Lockout Device.min.jpg"),
      prod_title: "Emergency Switch/Mushroom push button Lockout Device",
      prod_desc:
        "Emergency Switch/Mushroom push button Lockout Device Material: made of whitish Polypropylene Color: standard color white, red or color options are available as per requirement. Locking Arrangement: total three numbers of padlock can be used to lockout the device at a time. Advantage: It is designed to fit easily around emergency stop button of normal size. This device is very safe, effective and ideal to lockout the emergency push buttons. Weight: 56 gram",
    },
    {
      prod_id: "MNS-PIN-OUT",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Single Pole Pin - Out type Circuit Breaker Lockout.min.jpg"),
      prod_title: "Single Pole Pin - Out type Circuit Breaker Lockout",
      prod_desc:
        "Pin out circuit breaker lockout device is used to provide locking to the miniature circuit breaker(Ideally for Single Pole MCBs) that is with appropriate small holes, Material Nylon, ABS, Metallic PIN and spring,Length of Pin can be expanded up to 8.5 mm on pressed Position. Color yellow Black,Outer Size Overall length in closed Position 43 mm, Edge Width at Green end 16.5 mm, Centre Width at Black Portion 17 mm, Grip Holder Black Length 24 mm, Grip Holder Black Width 24 mm Weight 7 gm",
    },
    {
      prod_id: "MNS-PIN-WIDE",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Single Pole Pin - Out-Wide type Circuit Breaker Lockout.min.jpg"),
      prod_title: "Single Pole Pin - Out-Wide type Circuit Breaker Lockout",
      prod_desc:
        "Pin out Wide breaker lockout device is used to provide locking to the miniature circuit breaker(Ideally for Single Pole MCBs) that is with appropriate small holes, Material Nylon, ABS, Metallic PIN and spring,Length of Pin can be expanded up to 8.5 mm on pressed Position. Color Blue Black,Outer Size Overall length in closed Position 43 mm, Edge Width at Green end 16.5 mm, Centre Width at Black Portion 17 mm, Grip Holder Black Length 24 mm, Grip Holder Black Width 24 mm Weight 7 gm",
    },
    {
      prod_id: "MNS-PIN-IN",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Single Pole Pin - In type Circuit Breaker Lockout.min.jpg"),
      prod_title: "Single Pole Pin - In type Circuit Breaker Lockout",
      prod_desc:
        "Pin In Circuit Breaker breaker lockout device is used to provide locking to the miniature circuit breaker(Ideally for Single Pole MCBs) that is with appropriate small holes, Material Nylon, ABS, Metallic PIN and spring,Length of Pin can be expanded up to 8.5 mm on pressed Position. Color Green Black,Outer Size Overall length in closed Position 43 mm, Edge Width at Green end 16.5 mm, Centre Width at Black Portion 17 mm, Grip Holder Black Length 24 mm, Grip Holder Black Width 24 mm Weight 7 gm",
    },
    {
      prod_id: "MNS-UCBL-N",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Multipole Universal Circuit Breaker Lockout - With Nose.min.jpg"),
      prod_title: "Multipole Universal Circuit Breaker Lockout - With Nose",
      prod_desc:
        "Universal Circuit Breaker Lockout It can be used for Single,double,triple and four pole MCB’s, Available – This model available in Nose / Without nose / Normal screw and fold able screw options. Material – High quality ABS and SS Finish screw Color – Red Size dimensions – length 56 mm, width 26 mm, Thickness 19 mm, Thickness at locking end 11mm, locking Hole diameter 9 mm, average Centre internal Grip 13.5 m Weight – 23 gm with fold able screw",
    },
    {
      prod_id: "MNS-UCBL-WN",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Multipole Universal Circuit Breaker Lockout - Without Nose and with Foldable Screw.min.jpg"),
      prod_title:
        "Multipole Universal Circuit Breaker Lockout - Without Nose and with Foldable Screw",
      prod_desc:
        "Universal Circuit Breaker Lockout It can be used for Single,double,triple and four pole MCB’s, Available – This model available in Nose / Without nose / Normal screw and fold able screw options. Material – High quality ABS and SS Finish screw Color – Red Size dimensions – length 56 mm, width 26 mm, Thickness 19 mm, Thickness at locking end 11mm, locking Hole diameter 9 mm, average Centre internal Grip 13.5 m Weight – 23 gm with fold able screw",
    },
    {
      prod_id: "MNS-LT-PT-1",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Universal Circuit Breaker Lockout - Without Nose and with inserted Screw.min.jpg"),
      prod_title:
        "Universal Circuit Breaker Lockout - Without Nose and with inserted Screw",
      prod_desc:
        "Miniature Circuit Breaker Lockout This MCB lockout can easily installed. It can use for Single and double pole MCB, Padlock use to lock this lockout with Screw Driver Material – High quality ABS and SS Finish screw Colour – Yellow Weight – 12 gm for with normal screw type",
    },
    {
      prod_id: "MNS-MUCBL-Y",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Miniature Circuit Breaker lockout - with Foldable Screw.min.jpg"),
      prod_title: "Miniature Circuit Breaker lockout - with Foldable Screw",
      prod_desc:
        "Miniature Circuit Breaker Lockout This MCB lockout can easily installed. It can use for Single,double,triple and four pole MCB, Padlock use to lock this lockout No Screw Driver Required Available – This model available in Nose / Without nose / Normal screw and fold able screw options. Material – High quality ABS and SS Finish screw Colour – Yellow Size dimensions – Centre length 58 mm, width at curve 29.5 mm, Width at lower end 24.5 mm, Thickness 13 mm, Internal Hole diameter 9 mm, Average center internal Grip 8 mm Weight – 22 gm for with fold able screw and 14 gm for normal screw type",
    },
    {
      prod_id: "MNS-MUCBL-B",
      prod_img: require("../assets/img/Electrical-Lockout-Products/miniature circuit breaker-Blue.min.jpg"),
      prod_title:
        "Miniature Circuit Breaker lockout - without Foldable Screw-Blue",
      prod_desc:
        "Miniature Circuit Breaker Lockout,It can use for Single,double,triple and four pole MCB,Padlock use to lock this lockout with Screw Driver. Available – This model available in Nose / Without nose / Normal screw and fold able screw options. Material – High quality ABS and SS Finish screw Colour – Blue Size dimensions – Centre length 49 mm, center width 23 mm, Width at locking end 13.5 mm, Thickness 25 mm, Internal Hole diameter 8 mm, Average center internal Grip 12.5 mm Weight – 30 gm for with fold able screw, 22 gm for normal screw type and 40 gm for with nose type.",
    },
    {
      prod_id: "MNS-TBRL",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Tie Bar Circuit Breaker Lockout.min.jpg"),
      prod_title: "Tie Bar Circuit Breaker Lockout",
      prod_desc:
        "Tie Bar Circuit Breaker Can be used for two, three or four pole. Material - ABS with metallic threaded bolt and steel strip Color - Red Color Dimension:Outer Size - length with bolt 57 mm, without bolt 47 mm, average width 24 mm, thickness 13 mm, width 33.5 mm, Hole diameter 7.5 mm Weight - 30 gm",
    },
    {
      prod_id: "MNS-LFCBL",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Large Fuse Circuit Breaker.min.png"),
      prod_title: "Large Fuse Circuit Breaker",
      prod_desc:
        "Universal fuse circuit breaker lockout Device used for isolating fuse holder. Available in plain and folding screw that is used to lock fuse holders of 20 Amp to 400 Amp current. Color - Red, Yellow. Size - Center to center length 72 mm, width at center 33.5 mm, thickness 16 mm, hole diameter 8 mm, center internal thickness grip 7.5 mm. Weight - 20 gm for plain screw and 30 gm for foldable screw. Material - High quality ABS with metallic nut.",
    },
    {
      prod_id: "MNS-LCBL-N",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Large Circuit Breaker Lockout with Nose.min.jpg"),
      prod_title: "Large Circuit Breaker Lockout with Nose",
      prod_desc:
        "Large Circuit Breaker Lockout can be used for lockout a wide range of three phase Circuit Breakers 227 V & above, Fits on lever of Circuit Breaker up to 3″ wide & 0.9″ thick, Available with Normal Foldable Screw and can be tightened with Screw Driver Rugged Stainless Steel / PVC Constructions Corrosion resistant Description – Large circuit breaker lockout Device Bolt Fixed with round portion Size – Center length 74 mm, Width with gripping teeth 22.5 mm,Width up to gripping teeth 20 mm, Centre Hole dia 8 mm Colour – Red Weight – 67 gms",
    },
    {
      prod_id: "MNS-LCBL-R",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Large Round circuit breaker Lockout.min.jpg"),
      prod_title: "Large Round circuit breaker Lockout",
      prod_desc:
        "Large Circuit Breaker Lockout can be used for lockout a wide range of three phase Circuit Breakers 227 V & above ,Fits on lever of Circuit Breaker up to 3″ wide & 0.9″ thick, make it easy to secure the large Circuit Breakers at any workplace. Rugged Stainless Steel / PVC Constructions Corrosion resistant Description – Large circuit breaker lockout Device Bolt Fixed with round portion All 12 holes to place the padlock Size – Center length 74 mm, Width with gripping teeth 22.5 mm,Width up to gripping teeth 20 mm, Centre Hole dia 8 mm Colour – Red Weight – 67 gms",
    },
    {
      prod_id: "MNS-BLK",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Breaker Lockout KIT –for 480-600 V-Pre adhesive rails-no drilling required.min.jpg"),
      prod_title:
        "Breaker Lockout KIT –for 480-600 V-Pre adhesive rails-no drilling required",
      prod_desc:
        "Breaker Lockout Kit Large For (480-600 V) switches comes with Pre adhesive rails no drilling require Suitable for application on oversized shaped switches and to lock combined MCB’s and panel breakers",
    },
    {
      prod_id: "MNS-SCL",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Scissor Shaped cable Lockout - Along with 2 meter RED cable Length.min.jpg"),
      prod_title:
        "Scissor Shaped cable Lockout - Along with 2 meter RED cable Length",
      prod_desc:
        "Scissor cable lockout with insulated cable that is having totally six holes in scissor for group isolation. Insulated steel Cable of length 2 mtr, thickness 5 mm, Material ABS and Mild stainless steel insulated cable,Hole Dia:9mm Color-Red",
    },
    {
      prod_id: "MNS-MCL",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Multipurpose cable Lockout with 2 meter looped cable.min.jpg"),
      prod_title: "Multipurpose cable Lockout with 2 meter looped cable",
      prod_desc:
        "This device can be used to lockout huge range of industrial plant equipments either electrical, mechanical and even forklift steering wheels. Material composition : ABS and Mild Stainless Steel base internal plate Parts : Outer part made of ABS and internal part made of Mild SS with chrome finish having 6 holes for group locking Colour : Red and another colour can make as per customer requirement Dimensions : Length – 150mm, Width – 46mm, internal hole – Diameter 10mm Weight :150 gm",
    },
    {
      prod_id: "MNS-RMCL",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Round-shaped-adjustable-Multipurpose-Cable-Lockout.min.jpg"),
      prod_title: "Round shaped adjustable Multipurpose Cable Lockout",
      prod_desc:
        "Round Multipurpose Cable lockout:Cable Injection molded lockout comprising of Stainless Steel nut and bolt for corrosion free, long lasting with 2 Mtrs Galvanized Vinyl Coated Steel Cable, This design applicable for 8 padlocks to Withstands Temperatures ( +55° C to -20º C ), Ideal lockout for gate valve sizes above 381mm,Any length can provide as per customer requirement. Colour : Red or any other on customer requirement Dimensions : Round Dia : 40mm, Bolt Dia – 15mm and hole dia – 8mm Weight : 95 gms (Body weight – 40 gm and cable weight – 55 gms)",
    },
    {
      prod_id: "MNS-EPL-RS",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Electrical Panel Lockout-Small.min.jpg"),
      prod_title: "Electrical Panel Lockout-Small",
      prod_desc:
        "Electrical Panel Lockout made of transparent material including 2 parts - Small round shape. Lower outer base size - 35 x 35 mm having innier hollow portion of sixe 27.5 x 27.5 mm + upper part- of size - 35mm x 40 mm -with provision of locking",
    },
    {
      prod_id: "MNS-EPL-L-RS90/45",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Electrical Panel Lockout-90-45.min.jpg"),
      prod_title: "Electrical Panel Lockout-90/45",
      prod_desc:
        "Electrical Panel Lockout made of transparent material including 2 parts - Large round shape with provision of cuts to rotate the handle at 45 or 90 degree.Size outer square base -95 x 95 mm with inner dia - 75 mm and upper part of internal size -dia 80 mm and depth 65 mm, Weight: 85 Gms",
    },
    {
      prod_id: "MNS-EPLS-SQ",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Electrical Panel Lockout-Square.min.jpg"),
      prod_title: "Electrical Panel Lockout-Square",
      prod_desc:
        "Electrical Panel Lockout made of transparent material including 2 parts - Small Square shape.Size outer base -66 x 66 mm,inner base size: 45 x 45 mm and upper part of internal size - 50 x 50 mm and depth 56 mm",
    },
    {
      prod_id: "MNS-MEPL-BX",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Multipurpose Large Electrical Panel Lockout box.min.jpg"),
      prod_title: "Multipurpose Large Electrical Panel Lockout box",
      prod_desc:
        "Multipurpose Electrical Panel Lockout box made of MS sheet with Grey, Yellow or Red colour powder coating with side locking arrangement for locking Electrical Panels/Switches, OUTER SIZE : 130 x 130 x 130 mm, INNER SIZE –100 x 100 mm",
    },
    {
      prod_id: "MNS-PLE-LB",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Right angled Padlock eye - Large size (set of 10 Nos).min.jpg"),
      prod_title: "Right angled Padlock eye - Large size (set of 10 Nos)",
      prod_desc:
        "Right angled Padlock eye - Large size Suitable for Electrical Panel Door Locking for additional Safety with Revits,Comes in Set",
    },
    {
      prod_id: "MNS-DEHL",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Electrical Handle Panel lockout.min.jpg"),
      prod_title: "Electrical Handle Panel lockout",
      prod_desc:
        "Electrical Handle Panel lockout - Lockout for electrical panels- having 4 parts + small lock , one base and insert slotter part made of ABS and steel made long foldable strip having holes for locking arrangement, A perfect Solutions for OLD ELECTRICAL PANELS/BREAKERS where LOCKOUT ARRANGEMENTS are NOT AVAILABLE.",
    },
    {
      prod_id: "MNS-DI-PL",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Di-Electric-Round-Shape-Lockout.min.jpg"),
      prod_title: "Di-Electric Round Shape Lockout",
      prod_desc:
        "Lockout Di-electric Panel Cover in round shape made of ABS material available in Red/Yellow colour having two parts upper and lower, both parts fixes with the help of rivet.can easily fixed with pre adhesive liner,having locking provision. Dimension – Outer Diameter is 46 mm, Inner Diameter is 32 mm, lower cover circle side thickness is 7 mm, overall thickness is 8 mm with upper part thickness 3mm and lower part thickness is 5 mm, locking hole diameter 7 mm, Ideal for Breaker Charger Isolation/Panel Door Locking",
    },
    {
      prod_id: "MNS-UMDL",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Cylinder Universal Multi device Lockout Device.min.jpg"),
      prod_title: "Cylinder /Universal Multi device Lockout Device",
      prod_desc:
        "Cylinder/Universal Multi device Lockout Non conductive Product for PNEUMATIC Devices- Size -88 mm dia x 155 mm ( 3.45 DiaX 6.10 L)",
    },
    {
      prod_id: "MNS-SPCL",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Pneumatic Plug chord lockout-Small.min.jpg"),
      prod_title: "Pneumatic Plug chord lockout-Small",
      prod_desc:
        "Pneumatic Plug chord lockout Made of polypropylene. Completely encloses electrical plugs to prevent accidental re-connection – SMALL UV Resistant quality. With 75mm dia hole for Wire. Dimensions : Inner Length 83mm and inner dia – 43 mm Outer Length – 88mm",
    },
    {
      prod_id: "MNS-LPCL",
      prod_img: require("../assets/img/Electrical-Lockout-Products/Pneumatic Plug chord lockout-Large.min.jpg"),
      prod_title: "Pneumatic Plug chord lockout-Large",
      prod_desc:
        "Plug Lockout – Large made of Polypropylene Plastic material having UV Resistant quality.With 1” dia hole for Wire. Dimensions : Inner Length 190mm and inner dia – 55-80 mm Outer Length – 197mm",
    },
  ],
  mechanical_lockout: [
    {
      prod_id: "MNS-GVL-02",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Gate Valve Lockout for Dia Size - 25 to 63.5mm.min.jpg"),
      prod_title: "Gate Valve Lockout for Dia Size - 25 to 63.5mm",
      prod_desc:
        "Gate valve cover, Bind gate valve to rotate freely once locked Resistant to extreme weather and temperature conditions can withstand temperatures from 20 degree F – 200 degree F Color – RED Gate Valve Lockout for Dia Size – 25 to 63.5mm – Inside Dia – 66mm, Inside height – 36mm, Outside Dia – 80mm, Outside height – 41mm, Lock hole – 9mm, number of holes – 2",
    },
    {
      prod_id: "MNS-GVL-04",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Gate Valve Lockout for Dia Size - 63.5 to 127mm.min.png"),
      prod_title: "Gate Valve Lockout for Dia Size - 63.5 to 127mm",
      prod_desc:
        "Gate valve cover, Bind gate valve to rotate freely once locked Resistant to extreme weather and temperature conditions can withstand temperatures from 20 degree F – 200 degree F Color – RED Gate Valve Lockout for Dia Size – 63.5 to 127mm –Inside Dia – 132mm, Inside height – 43mm, Outside Dia – 148mm, Outside height – 49mm, Lock hole – 9mm, number of holes – 3",
    },
    {
      prod_id: "MNS-AGVL-06",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Adjustable Gate valve lockout device - 25 MM to 190 mm.min.jpg"),
      prod_title: "Adjustable Gate valve lockout device - 25.4 MM to 190 mm",
      prod_desc:
        "Adjustable Gate valve cover, Bind gate valve to rotate freely once locked Resistant to extreme weather and temperature conditions can withstand temperatures from 20 degree F – 200 degree F Color – RED Gate Valve Lockout for Dia Size – Gate Valve Lockout for Dia Size - 25.4 to 190mm,Inside height – 45mm, Outside Dia – 250mm, Outside height – 48mm, Lock hole – 9mm, number of holes – 5",
    },
    {
      prod_id: "MNS-BV-01-LL-EX",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/newproduct2.min.jpg"),
      prod_title: "Ball Valve Lockout",
      prod_desc:
        "Ball Valve Lockout - Standard-small with long open length for valves up to 2½ “(63.5 MM ) with side extension",
    },
    {
      prod_id: "MNS-GVL-08",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Gate Valve Lockout for Dia Size - 165 to 280 mm.min.jpg"),
      prod_title: "Gate Valve Lockout for Dia Size - 165 to 280 mm",
      prod_desc:
        "Gate valve cover, Bind gate valve to rotate freely once locked Resistant to extreme weather and temperature conditions can withstand temperatures from 20 degree F – 200 degree F Color – RED Gate Valve Lockout for Dia Size – 165 to 280mm – Inside Dia – 280mm, Inside height – 51mm, Outside Dia – 290mm, Outside height – 64mm, Lock hole – 9mm, number of holes – 3",
    },
    {
      prod_id: "MNS-GVL-10",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Gate Valve Lockout for Dia Size - 280 to 381 mm.min.jpg"),
      prod_title: "Gate Valve Lockout for Dia Size - 280 to 381 mm",
      prod_desc:
        "Gate valve cover, Bind gate valve to rotate freely once locked Resistant to extreme weather and temperature conditions can withstand temperatures from 20 degree F – 200 degree F Color – RED Gate Valve Lockout for Dia Size – 280 to 381mm – Inside Dia – 381mm, Inside height – 61mm, Outside Dia – 392mm, Outside height – 73mm, Lock hole – 9mm, number of holes – 3",
    },
    {
      prod_id: "MNS-MBV",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/metal ball valve.min.jpg"),
      prod_title: "Metal Ball Valve",
      prod_desc:
        "Metal Ball Valve Lockout: Material : MS + powder coated body, Locking holes : 6 / 7 numbers. Accepts shackle maximum up to : 9.6mm, Corrosion resistant, high temperature compatible, device is used to lockout the perpendicular / OFF ball valves to avoid unexpected energisation or start up of valve at work place. Fits valves 1/4” to 1”86 gm, Large Fits valves 1.25” to 3”353.5 gm",
    },
    {
      prod_id: "MNS-BV-01-ST",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Ball Valve Lockout - Standard - Small.min.jpg"),
      prod_title: "Ball Valve Lockout - Standard - Small",
      prod_desc:
        "Ball Valve Lockout - Standard - Small for Valves from - 9.5 mm to 31.5 mm (3/8 to 1¼ ) width – 75mm x Length – 77mm x Length of Handle – 135mm – 230mm Having 9mm hole for Locking 7 holes in upper part 6 holes in lower part",
    },
    {
      prod_id: "MNS-BV-01-01-ST + ST-EX",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Ball Valve Lockout - Standard - Small1.min.png"),
      prod_title:
        "Ball Valve Lockout - Standard - Small for Valves from - 9.5 mm to 31.5 mm (3/8 to 1¼ )with side extensions attachment.",
      prod_desc:
        "Ball Valve Lockout - Standard - Small for Valves from - 9.5 mm to 31.5 mm (3/8 to 1¼ )with side extensions attachment.",
    },
    {
      prod_id: "MNS-BV-01-LL",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Ball Valve Lockout - Standard-small with long open length for valves up to 2½ “(63.5 MM ).min.jpg"),
      prod_title:
        "Ball Valve Lockout - Standard-small with long open length for valves up to 2½ “(63.5 MM )",
      prod_desc:
        "Ball Valve Lockout - Standard-small with long open length for valves up to 2½ “(63.5 MM )width – 75mm x Length – 77mm x Length of Handle – 135mm – 230mm Having 9mm hole for Locking 7 holes in upper part",
    },
    {
      prod_id: "MNS-BV-01-DL-EX",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Ball Valve Lockout – Double Leg for valves up to 2½  ( 63.5 MM ).min.jpg"),
      prod_title:
        "Ball Valve Lockout – Double Leg for valves up to 2½ ( 63.5 MM )",
      prod_desc:
        "Ball Valve Lockout Having Double Leg for valves up to 2½ ” ( 63.5 MM ) width – 75mm x Length – 77mm x Length of Handle – 135mm – 230mm Having 9mm hole for Locking 7 holes in upper part 6 holes in lower part",
    },
    {
      prod_id: "MNS-BV-01-DL",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Ball Valve Lockout - Double Leg with long open length for valves up to 2½ “ ( 63.5 MM ).min.png"),
      prod_title:
        "Ball Valve Lockout - Double Leg with long open length for valves up to 2½ “ ( 63.5 MM )",
      prod_desc:
        "Ball Valve Lockout - Double Leg with long open length for valves up to 2½ “ ( 63.5 MM )",
    },
    {
      prod_id: "MNS-BV-01-DL-LL-EX",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/newproduct1.min.jpg"),
      prod_title:
        "Ball Valve Lockout - Double legs long length arm for Ball Valve Dia 1½ - 2½",
      prod_desc:
        "Ball Valve Lockout - Double legs long length arm for Ball Valve Dia 1½ - 2½",
    },
    {
      prod_id: "MNS-BV-02-LS",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Ball Valve Lockout for valves from 2”- 8 (50.8 MM TO 203.20MM ).min.jpg"),
      prod_title:
        "Ball Valve Lockout for valves from 2'- 8' (50.8 MM TO 203.20MM )",
      prod_desc:
        "Ball Valve Lockout For valves from 2”- 8″ (50.8 MM TO 203.20MM ) width – 100mm x Length – 180mm x Length of Handle – 290mm – 515mm Having 9mm hole for Locking 13 holes in upper part 6 holes in lower part",
    },
    {
      prod_id: "MNS-BFV",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Butterfly valve lockout.min.jpg"),
      prod_title: "Butterfly valve lockout",
      prod_desc:
        "Butterfly valve lockout Locking Slots – 12 slots at bottom part and 6 holes at upper small part, Size of lower part, Total Length – 300mm Width at back end – 70mm. Width at front end – 100mm. Internal Height to accommodate handle /lever : 25mm. Internal width : 48 mm ( accommodate lever width ). Cut out size : 50 x 50 mm in taper shape, Size of upper small part : Length : 100 mm, Width : 70 mm Material : Poly Propylene – UV Colour",
    },
    {
      prod_id: "MNS-BV-01-DL-LL",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Ball Valve Lockout - Double Leg with long open length for valves up to 2½ “ ( 63.5 MM ).min.png"),
      prod_title:
        "Ball Valve Lockout - Double Legwith long open length for valves up to 2½ “ ( 63.5 MM )",
      prod_desc:
        "Ball Valve Lockout - Double Legwith long open length for valves up to 2½ “ ( 63.5 MM )",
    },
    {
      prod_id: "MNS-LS-Y",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Lockable Lockout Station-without material.min.jpg"),
      prod_title: "Lockable Lockout Station-without material",
      prod_desc:
        "Lockable Lockout Station-without material made of MS powder coated sheet with front side Transparent acrylic cover and lock . Size : 14' x 16' x 6' having provision of two Adjustable shelves for placing the other items Available colours : Yellow",
    },
    {
      prod_id: "MNS-LS-K",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Lockable Key Station-Without Material.min.png"),
      prod_title: "Lockable Key Station-Without Material",
      prod_desc:
        "Lockable Key Station -without material made of MS powder coated sheet with front side Transparent acrylic cover and lock . Size : 18.25' x 15.5' x 2' having provision of hooks for tags and padlocks Available colours : Grey for 48 keys",
    },
    {
      prod_id: "MNS-PLS-H",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Lockable Padlock Station-With Hooks-Without Material.min.jpg"),
      prod_title: "Lockable Padlock Station-With Hooks-Without Material",
      prod_desc:
        "Lockable Padlock Station -without material made of MS powder coated sheet with front side Transparent acrylic cover and lock . Size : 18' x 15' x2' having provision of hooks for tags and padlocks With Wall Mounting Option, Available colours : Red/Yellow",
    },
    {
      prod_id: "MNS-PLS-H/S",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Lockable Padlock Station-With HooksShelf-Without Material.min.jpg"),
      prod_title: "Lockable Padlock Station-With Hooks/Shelf-Without Material",
      prod_desc:
        "Lockable Padlock Station -without material made of MS powder coated sheet with front side Transparent acrylic cover and lock . Size : 30' x 15' x9' having provision of hooks/Shelf for tags and padlocks Available colours : Red/Yellow",
    },
    {
      prod_id: "MNS-MLS",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Multipurpose-Lockout-station-Size-36x46x16.min.png"),
      prod_title: "Multipurpose Lockout station-Size : 36' x 46' x16'",
      prod_desc:
        "Lockable Lockout Station-without material made of MS powder coated sheet with front side Transparent acrylic cover and lock . Size : 36' x 46' x1 6' having provision of two Adjustable shelves for placing the other items Available colours : Red/Yellow",
    },
    {
      prod_id: "MNS-ELS-WM",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Electrical-Lockout-Station-with-Material.min.jpg"),
      prod_title: "Electrical Lockout Station with Material",
      prod_desc:
        "Lockable Electrical Lockout Station-with Elecrtical Loto material made of MS powder coated sheet with front side Transparent acrylic cover and lock . Size : 14' x 16' x 6' having provision of two Adjustable shelves for placing the other items Available colours : Yellow",
    },
    {
      prod_id: "MNS-MLS-WM",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Mechanical Lockout Station with Material.min.jpg"),
      prod_title: "Mechanical Lockout Station with Material",
      prod_desc:
        "Lockable Mechanical Lockout Station-with Mechanical Loto material made of MS powder coated sheet with front side Transparent acrylic cover and lock . Size : 14' x 16' x 6' having provision of two Adjustable shelves for placing the other items Available colours : Yellow",
    },
    {
      prod_id: "MN-ILTSK-3",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Multipurpose Industrial Lockout Station-3-With Material.min.jpeg"),
      prod_title: "Multipurpose Industrial Lockout Station-3-With Material",
      prod_desc:
        "Multipurpose Industrial Lockout Station-3 Lockable Lockout Station-with material made of MS powder coated sheet with front side Transparent acrylic cover and lock . Size : 14' x 16' x 6' having provision of two Adjustable shelves for placing the other items Available colours : Yellow",
    },
    {
      prod_id: "MNS-WP",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Multipurpose Waist pouch loto Bag.min.png"),
      prod_title: "Multipurpose Waist pouch loto Bag",
      prod_desc:
        "Multipurpose Waist pouch made of Export Quality Fabric with Min. 2 pocket to keep small electrical lockout devices Tags, tie, pen, tie, multi isolation items - WITHOUT ANY MATERIAL EMPTY POUCH/Color-Red/Black and Blue Available",
    },
    {
      prod_id: "MNS-ML-KIT",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Mechanical Lockout bag Kit-With material.min.jpg"),
      prod_title: "Mechanical Lockout bag Kit-With material",
      prod_desc: "Mechanical Lockout bag Kit/Mini Lockout Kit with Material",
    },
    {
      prod_id: "MNS-MEKIT",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Mini Electrical Lockout Bag Kit-With Material.min.jpg"),
      prod_title: "Mini Electrical Lockout Bag Kit-With Material",
      prod_desc: "Mini Electrical Lockout Bag Kit With Material",
    },
    {
      prod_id: "MNS-MELK",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Medium Electrical Lockout bag Kit-With Material.min.jpg"),
      prod_title: "Medium Electrical Lockout bag Kit-With Material",
      prod_desc: "Medium Electrical Lockout Bag Kit- with Material",
    },
    {
      prod_id: "MNS-LEMLK",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Large Electro-Mechanical  LOTO Bag KIT-With Material.min.jpg"),
      prod_title: "Large Electro-Mechanical LOTO Bag KIT-With Material",
      prod_desc:
        "Large Electro-Mechanical Multipurpose LOTO Bag KIT with Material",
    },
    {
      prod_id: "MNS-GLB-R-L",
      prod_img: require("../assets/img/Mechanical-Lockout&Lockout-Stations/Group lockout Box.min.png"),
      prod_title: "Group lockout Box",
      prod_desc:
        "Group lockout Box with 16 slots made of metallic material sheet with powder coated having multiple slot for padlocks and lockable arrangement. Group lockout size : 253 x 154 x 110 ( +-10% )-Without padlocks",
    },
  ],
  industrial_safety_items: [
    {
      prod_id: "MNS-11-KV",
      prod_img: require("../assets/img/Industrial-Safety-Items/11 KV Rubber Hand Gloves.min.jpg"),
      prod_title: "11 KV Rubber Hand Gloves",
      prod_desc:
        "11 KV Rubber Hand Gloves-first class 11 KV Rubber Hand Gloves. Product Details: Exceptional finish",
    },
    {
      prod_id: "MNS-22-KV",
      prod_img: require("../assets/img/Industrial-Safety-Items/22KV Rubber Hand Gloves.min.jpg"),
      prod_title: "22KV Rubber Hand Gloves",
      prod_desc:
        "Superior class 22 KV Rubber Hand Gloves Product Details: Easily washable",
    },
    {
      prod_id: "MNS-33-KV",
      prod_img: require("../assets/img/Industrial-Safety-Items/33 KV Rubber Hand Gloves.min.jpg"),
      prod_title: "33 KV Rubber Hand Gloves",
      prod_desc:
        "33 KV Rubber Hand Gloves - Resistant against chemicals,Chlorinated surface,Excellent finishing, Exact sizes,High tear strength and longer durability",
    },
    {
      prod_id: "MN-K-Gloves",
      prod_img: require("../assets/img/Industrial-Safety-Items/Kevlar Heat Resistant Gloves.min.jpg"),
      prod_title: "Kevlar Heat Resistant Gloves",
      prod_desc:
        "Kevlar Heat Resistant Gloves-Color Yellow Finger Type Full Fingered Material Nomex IIIA Made from Kevlar fabric and stitched with Kevlar threads, Inside woolen and FR fabric lining Heat resistance upto 550 degree Celsius continuous working temperature and 850 degree short term working temperature.",
    },
    {
      prod_id: "MNS-C-Gloves",
      prod_img: require("../assets/img/Industrial-Safety-Items/Cotton Knitted Safety Gloves.min.jpg"),
      prod_title: "Cotton Knitted Safety Gloves",
      prod_desc: "Cotton Knitted Safety Gloves",
    },
    {
      prod_id: "MNS-ISG",
      prod_img: require("../assets/img/Industrial-Safety-Items/Safety-Gloves-Standard.min.jpg"),
      prod_title: "Safety Gloves-Standard",
      prod_desc: "All Types of Standard Industrial Gloves for Hand Protection",
    },
    {
      prod_id: "MNS-RSJ",
      prod_img: require("../assets/img/Industrial-Safety-Items/Florescent Reflective Mesh Jacket.min.jpg"),
      prod_title: "Florescent Reflective Mesh Jacket",
      prod_desc:
        "Florescent Reflective Mesh Jacket EN-471 CE Approved with White & Yellow green reflective Tape. Reflective Tape 2 Inch,Sizes:S-XXX Fabric color available :- Orange Green, Yellow",
    },
    {
      prod_id: "MNS-CPS",
      prod_img: require("../assets/img/Industrial-Safety-Items/Chemical Protection Suits.min.jpg"),
      prod_title: "Chemical Protection Suite",
      prod_desc:
        "Polyester Overall Chemical Protection Suit Full Sleeves,Sizes:Large,Medium and Small, Color-Yellow",
    },
    {
      prod_id: "MNS-STS",
      prod_img: require("../assets/img/Industrial-Safety-Items/Steel Toe Safety Shoes.min.jpg"),
      prod_title: "Steel Toe Safety Shoes",
      prod_desc:
        "Steel Toe Safety Shoe. These steel toe work shoes are available in different sizes and thickness. Our shoe model is absolutely resistant to heat so they very well cater to allied needs of the industries and High-grade quality, provide comfort. These Steel Toe Cap Safety Shoes are made under the skilled expertise of our professionals, as they hold expertise in domain. Moreover, our Steel Toe Cap Safety Shoes provide high comfort to the wearer. Features: • Long life • High-grade quality • Excellent strength • Heat resistance • Size: 4-12 • Colour: Black",
    },
    {
      prod_id: "MN-BLSS",
      prod_img: require("../assets/img/Industrial-Safety-Items/Black Labour Safety Shoes.min.jpg"),
      prod_title: "Black Labour Safety Shoes",
      prod_desc:
        "Black Labour Safety Shoes, Sole Type: PVC, Size: 5-11,Color: Black,Features: Low Cost, Usage/Application: Construction,Sole Type: PVC",
    },
    {
      prod_id: "MN-BLS",
      prod_img: require("../assets/img/Industrial-Safety-Items/Black Leather Safety Shoes.min.jpg"),
      prod_title: "Black Leather Safety Shoes",
      prod_desc:
        "Industrial and Construction Safety Shoes, Size: 6 -11 Ankle Length: Low and High Features: Anti-skid, Anti-static, Chemical Usage/Application: Industrial and Construction Material: Leather",
    },
    {
      prod_id: "MNS-GB",
      prod_img: require("../assets/img/Industrial-Safety-Items/PVC Gumboot Shoes.min.jpg"),
      prod_title: "PVC Gumboot Shoes",
      prod_desc:
        "PVC Gumboot Shoes,Waterproof,Anti-Skid, Oil Resistant, Water Resistant, Chemical Resistant, Color: Black, Application: Industrial, Agriculture, Construction, Length-Full",
    },
    {
      prod_id: "MNS-Convex Mirror",
      prod_img: require("../assets/img/Industrial-Safety-Items/Convex Mirror.min.jpg"),
      prod_title: "Convex Mirror",
      prod_desc:
        "Convex Mirror sizes available, 45, 60, 80, 100, 120 cm, Wall Mounted, Circular, Polycarbonate with fiber molded back water proof & weather proof",
    },
    {
      prod_id: "MNS-LSH",
      prod_img: require("../assets/img/Industrial-Safety-Items/Labour Safety Helmet.min.jpg"),
      prod_title: "Labour Safety Helmet",
      prod_desc: "PE Yellow Labour Safety Helmet, Size: Large",
    },
    {
      prod_id: "MNS-ERH",
      prod_img: require("../assets/img/Industrial-Safety-Items/Electrical-rescue-hook.min.jpg"),
      prod_title: "Electrical Rescue Hook",
      prod_desc:
        "Static/ Electrical Rescue Hook & Stick, Features: Static, Color: Yellow, Material: FRP, Length: 6-8",
    },
    {
      prod_id: "MNS-FAB",
      prod_img: require("../assets/img/Industrial-Safety-Items/first-aid-box-.min.jpg"),
      prod_title: "First Aid Box",
      prod_desc:
        "First Aid Box are the most preferred selections of clients owing to precise design, accurate dimensions, longer functional life and effective usage. With the availability in various ranges, these products are easily available with us at market leading rates. Features: - Easy to use - Light weight - Fine quality",
    },
    {
      prod_id: "MNS-SG",
      prod_img: require("../assets/img/Industrial-Safety-Items/safety-goggles-Black.min.jpg"),
      prod_title: "Black/White Industrial Safety Goggle",
      prod_desc:
        "Black/White Industrial Safety Goggle, Application: Industrial Frame Colour: black Lenses Material: Polycarbonate Frame Material: Acrylic",
    },
    {
      prod_id: "MNS-SCBA",
      prod_img: require("../assets/img/Industrial-Safety-Items/Self Contained Breathing Apparatus(SCBA).min.jpg"),
      prod_title: "Self Contained Breathing Apparatus(SCBA)",
      prod_desc:
        "Breathing SCBA Set-Avalilable in Steel and Carbon Cylinders, Duration30, 45 and 60 Minutes, Variuos Brands Scott, Honeywell, Drager, Centurian with EN and ISI Approval",
    },
    {
      prod_id: "MNS-FB",
      prod_img: require("../assets/img/Industrial-Safety-Items/Fibre Glass White Fire Blanket.min.jpeg"),
      prod_title: "Fibre Glass White Fire Blanket",
      prod_desc:
        "Fibre Glass White Fire Blanket, for Fire Fighting Non Disposable,Temperature Resistance: 150 Color: White,Abrasion Resistance,Thickness 0.8 mm Size 1 x 2 mtr",
    },
    {
      prod_id: "MN-AFS",
      prod_img: require("../assets/img/Industrial-Safety-Items/Aluminized Fire Proximity Suit.min.png"),
      prod_title: "Aluminized Fire Proximity Suit",
      prod_desc:
        "Aluminized Fire Proximity Suit, Gender: Unisex Size: Free Size, Product Description 1) Outer Layer Made from Imported Aluminized Glass Fibre Fabric with Inner Liner of woollen & FR Cotton. 2) Stitched with Kevlar thread. 3) It consists of Coat, Pant, Hood, Visor and Fibre glass Fireman Helmet as per IS-2745. 4)Gloves with FR & woollen lining and insulation. 5) Superior quality Shoes with oil skid and heat resistance. 6) Suitable for proximity fire industrial radiant heat up to 800C, convection heat 500 C. 7) Size: XL size with elastic pants (with belt) hence allowing one size to fit all. 8) Certifications- Made out of fabric which are tested and passed EN 531 & ISO11612",
    },
    {
      prod_id: "MNS-FBH",
      prod_img: require("../assets/img/Industrial-Safety-Items/full-body-safety-harness-belts.min.jpg"),
      prod_title: "Full Body Safety Harness- Belts, for Fall Protection",
      prod_desc:
        "Blue & Green Full Body Safety Harness- Belts, for Fall Protection Material: 100% Polyester Usage/Application: Fall Protection Color: Blue & Green Weight: 1.5-2kg Detachable",
    },
    {
      prod_id: "MNS-FRPL",
      prod_img: require("../assets/img/Industrial-Safety-Items/foldable-domestic-frp-ladder.min.jpg"),
      prod_title: "Foldable FRP Ladder",
      prod_desc:
        "Foldable FRP Ladder, Size: 120x48x17 Cm Application: Industrial Use Loading Capacity (kg): 80 /100 kg, Size: 120x48x17 cm",
    },
    {
      prod_id: "MN-SHFM",
      prod_img: require("../assets/img/Industrial-Safety-Items/Kesaf Scott Safety Profile 2 Half Face Mask.min.jpg"),
      prod_title: "Kesaf Scott Safety Profile 2 Half Face Mask",
      prod_desc:
        "Scott Safety Profile 2 Half Face Mask Material: Silicone Usage/Application: Fire & Safety Weight: 350 g Brand: 3M, Scott Safety's Profile2 is an advanced twin filter half mask that combines comfort, protection and low through life costs with exceptionally low breathing resistance, Perfectly balanced, user friendly and modern in design, Profile2 accepts the comprehensive range of highly efficient Scott Safety Pro2 gas, particulate and combined filters to provide respiratory protection in a wide variety of applications.",
    },
    {
      prod_id: "MNS-REP",
      prod_img: require("../assets/img/Industrial-Safety-Items/reusable-ear-plug.min.jpg"),
      prod_title: "Reusable-Ear-Plug",
      prod_desc:
        "Reusable-Ear-Plug, PU Material for Ear Protection, Wt:2.1Gm, Orange Color, Comfortable Light-weight, Durable",
    },
    {
      prod_id: "MNS-QMS",
      prod_img: require("../assets/img/Industrial-Safety-Items/q-managers.min.jpg"),
      prod_title: "Que Management System",
      prod_desc:
        "SS/MS Finish-Que Management System-With Fine Polyseter Tape available in 2.2 mtr, 2.75 mtr length with various colors,Used for crowd control management",
    },
    {
      prod_id: "MNS-BC",
      prod_img: require("../assets/img/Industrial-Safety-Items/Safety PVC Bump Cap.min.png"),
      prod_title: "Safety PVC Bump Cap",
      prod_desc:
        "Safety PVC Bump Cap,Available in Small, Medium, Large Sizes, Weight:230 Grams, Colors- Available",
    },
    {
      prod_id: "MNS-WHS",
      prod_img: require("../assets/img/Industrial-Safety-Items/Welding Head Shield.min.png"),
      prod_title: "Welding Head Shield",
      prod_desc:
        "Welding Head Shield- Sizes: Small, Medium, Large, Material: Polypropylene, Color: Black, Weight: 400 - 800 g",
    },
    {
      prod_id: "MNS-WG",
      prod_img: require("../assets/img/Industrial-Safety-Items/welding-goggles-1.min.jpg"),
      prod_title: "Industrial Welding Goggle",
      prod_desc:
        "Welding Goggle are something of a necessity in several industrial and construction related sectors. Size: Free Size, Color: Black",
    },
    {
      prod_id: "MNS-FMT",
      prod_img: require("../assets/img/Industrial-Safety-Items/floor-marking-tapes.min.jpg"),
      prod_title: "Floor Marking Tapes",
      prod_desc:
        "Yellow And Black Floor Marking Tape, Adhesive Side: Single Sided, Yellow and Black, Size: 1 inch, 2 inch, 3 inch, Waterproof, Heat Resistant, antistatic - 30 mtrs Roll",
    },
    {
      prod_id: "MNS-PPE",
      prod_img: require("../assets/img/Industrial-Safety-Items/Industrial-Safety-PPE-Products.min.png"),
      prod_title: "Industrial Safety PPE Products",
      prod_desc:
        "Industrial Safety PPE Products - Respiratory, Disposable, Safety, All Major Brands,Cut Resistant, Heat Resistant, Chemical Resistant, Acid Resistant, Cold Resistant, Alkali Resistant, Flame Resistant, Heat Preservation , Material: Cotton, Non-Woven, Pvc, Leather etc",
    },
  ],
  safety_posters: [
    {
      prod_id: "MNS-KHLTP",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Know-How-To-Lockout-Accidents-Poster.min.jpg"),
      prod_title: "Know How To Lockout Accidents- Poster",
      prod_desc:
        "Know How To Lockout Poster-Self adheive Hangouts Know How to Lockout made on high quality vinyl - Size: 18' X 24'",
    },
    {
      prod_id: "MNS-ESP",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Electric Shock First Aid Poster.min.jpg"),
      prod_title: "Electric Shock /First Aid Poster",
      prod_desc:
        "Electric Shock /First Aid Poster-Self adheive Hangouts made on high quality vinyl - Size: 18' X 24' (Available in Hindi & English)",
    },
    {
      prod_id: "MNS-LSP",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Basics ofLockout Safety- Poster.min.jpg"),
      prod_title: "Basics of Lockout Safety- Poster",
      prod_desc:
        "Self adheive Hangouts made on high quality vinyl - Size: 18' X 24' (Available in Hindi & English)",
    },
    {
      prod_id: "MNS-OSP",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Office_Safety_Poster.min.jpg"),
      prod_title: "Office Safety Poster",
      prod_desc:
        "Office Safety Poster-Self adheive Hangouts made on high quality vinyl - Size: 18' X 24' (Available in Hindi & English)",
    },
    {
      prod_id: "MNS-SRP",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Attention Safety-Rules Poster.min.jpg"),
      prod_title: "Attention Safety-Rules Poster",
      prod_desc:
        "Safety-Rules Poster-Self adheive Hangouts made on high quality vinyl - Size: 18' X 24' (Available in Hindi & English)",
    },
    {
      prod_id: "MNS-HPP",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Hand ProtectionUse PPE Poster.min.jpg"),
      prod_title: "Hand Protection/Use PPE Poster",
      prod_desc:
        "Hand Protection/Use PPE Poster-Self adheive Hangouts made on high quality vinyl - Size: 18' X 24' (Available in Hindi & English)",
    },
    {
      prod_id: "MNS-WSP",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/work Safety Poster.min.jpg"),
      prod_title: "Work Safety Poster",
      prod_desc:
        "Work Safety Poster-Self adheive Hangouts made on high quality vinyl - Size: 18' X 24'",
    },
    {
      prod_id: "MNS-EWSP",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Electrical Warning Sign Poster.min.jpg"),
      prod_title: "Electrical Warning Sign Poster",
      prod_desc:
        "Electrical Warning Sign Poster-Work Safety Poster-Self adheive Hangouts made on high quality vinyl - Size: 6' X 4'",
    },
    {
      prod_id: "MNS-CPP",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Chemical Pipe line Warning Sign Poster.min.jpg"),
      prod_title: "Chemical Pipe line Warning Sign Poster",
      prod_desc:
        "Chemical Pipe line Warning Sign Poster-Work Safety Poster-Self adheive Hangouts made on high quality vinyl - Size: 6' X 4'",
    },
    {
      prod_id: "MNS-CLP",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Caution-Power Isolation  Sign Poster.min.jpg"),
      prod_title: "Caution-Power Isolation Sign Poster",
      prod_desc:
        "Caution-Power Isolation Sign Poster-Work Safety Poster-Self adheive Hangouts made on high quality vinyl - Size: 6' X 4'",
    },
    {
      prod_id: "MNS-GSP",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/General Safety Poster.min.jpg"),
      prod_title: "General Safety Poster",
      prod_desc:
        "General Safety Poster-With Various Danger Signs,Self adheive Hangouts made on high quality vinyl - Size: 18' X 24' (Available in Hindi & English)",
    },
    {
      prod_id: "MNS-DLTP",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Danger-Lockout Tagout Power Isolation  Sign Poster.min.jpg"),
      prod_title: "Danger-Lockout Tagout Power Isolation Sign Poster",
      prod_desc:
        "Danger-Lockout Tagout Power Isolation Sign Poster-Work Safety Poster-Self adheive Hangouts made on high quality vinyl - Size: 6' X 4'",
    },
    {
      prod_id: "MNS-SAP-DO",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Electrical-Safety-Poster.min.jpg"),
      prod_title: "Electrical Safety Poster",
      prod_desc:
        "Self adheive Hangouts made on high quality vinyl - Size: 18' X 24' (Available in Hindi & English)",
    },
    {
      prod_id: "MNS-LTSP-E",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Lockout Tagout Safety Proceedure Poster-English.min.jpg"),
      prod_title: "Lockout Tagout Safety Procedure Poster-English",
      prod_desc:
        "Lockout Tagout Safety Procedure Poster-Lockout Tagout Safety Proceedure Poster-Self adheive Hangouts made on high quality vinyl - Size: 18' X 24' (Available in Hindi & English)",
    },
    {
      prod_id: "MNS-LTSP-H",
      prod_img: require("../assets/img/LocksTags&Hasp&SafetyPosters/Lockout Tagout Safety Proceedure Poster-Hindi.min.jpg"),
      prod_title: "Lockout Tagout Safety Procedure Poster-Hindi",
      prod_desc:
        "Lockout Tagout Safety Procedure Poster-Self adhesive Hangouts made on high quality vinyl - Size: 18' X 24' (Available in Hindi & English)",
    },
  ],
};
